<template>
  <div>
    <page-header
      has-return
      :has-continue="showContinue"
      :page="page"
      @onContinue="handleSubmit"
      @onReturn="$router.go(-1)"
    />

    <component
      :is="component"
      :cancel-appointment-action="params.appoinmentCancelAction"
      :cancel-appointment-id="params.cancelAppointmentId"
      :default-discipline="params.disciplineTypeId"
      :service-type-id="params.serviceTypeId"
      :client-appointment-id="clientAppointmentId"
      :student="student"
      :showCalendar="true"
      @select-schedule="selectSchedule"
      @contact-info="val => (contactInfo = val)"
      @confirm-save="backSuccess"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/common/page/PageHeader";
import AvailableAppoinment from "@/components/student/registry/components/tab5/AvailableAppointment";
import ConfirmAppointment from "@/components/student/registry/components/tab5/ConfirmAppointment";
import appointmentServices from "@/services/api/appointment.api.js";
import { ValidationObserver } from "vee-validate";
import mixAlert from "@/mixin/alert.mixin";
export default {
  name: "AppoinmentCoordination",
  mixins: [mixAlert],
  components: {
    PageHeader,
    AvailableAppoinment,
    ConfirmAppointment,
    ValidationObserver
  },
  data() {
    return {
      page: {
        icon: "fas fa-user-circle",
        title: "Manejo de Coordinación a Evaluación",
        routes: ["Inicio", "Estudiante", "Manejo de Coordinación a Evaluación"]
      },
      student: {},
      clientAppointmentId: null,
      contactInfo: null,
      component: "AvailableAppoinment",
      showContinue: false
    };
  },
  methods: {
    getStudentDetails() {
      this.$ApiGet("/api/student/getstudentdetails", {
        studentSie: this.params.studentSie
      }).then(({ data }) => {
        let regStudentId = data.mipeStudent.regStudentId;

        this.student = {
          ...data,
          regStudentId: regStudentId ? regStudentId.replace("-", "") : "",
          isInitialRegister: null
        };
      });
    },
    async selectSchedule(schedule) {
      if (!(schedule.scheduleId && schedule.scheduleId > 0)) return;

      let clientHasAppointement = false;
      await appointmentServices
        .isValidAvailableSpace(this.params.studentSie, schedule.scheduleId)
        .then(res => {
          clientHasAppointement = res.data;
        });

      if (clientHasAppointement) {
        this.ShowToast(
          "Alerta",
          "El estudiante tienen una cita para la fecha y hora seleccionada.",
          "error"
        );
        return;
      }

      this.clientAppointmentId = schedule.scheduleId;
      this.component = "ConfirmAppointment";
      this.showContinue = true;
    },
    async handleSubmit() {
      this.$store.state.tab.saveMethod({
        studentReferralId: this.params.studentReferralId
      });
    },
    backSuccess() {
      setTimeout(() => {
        this.$router.go(-1);
      }, 2000);
    }
  },
  computed: {
    params() {
      //if(this.$store.state.appointmentModule){
      return this.$store.state.appointmentModule.data;
      //}

      //return this.$route.query;
    }
  },
  created() {
    this.getStudentDetails();
  }
};
</script>
